import { Breakpoint } from '@altibox/lte-salgskanaler-design-system-component-lib';
import React from 'react';

import { StyledDetailsTitle, StyledText } from './order-details-row.styled';
import { DetailsRow } from './details-row';

interface Props {
  title: string;
  value: string;
  isValueSensitive?: boolean;
}

export const OrderDetailsRow = ({ title, value, isValueSensitive }: Props) => (
  <DetailsRow>
    <StyledDetailsTitle component="p" variant="paragraph3" maxBreakpoint={Breakpoint.TABLET}>
      {title}
    </StyledDetailsTitle>
    <StyledText
      component="p"
      variant="paragraph3"
      maxBreakpoint={Breakpoint.TABLET}
      data-hj-suppress={isValueSensitive}
    >
      {value}
    </StyledText>
  </DetailsRow>
);
